import { Component, Output, Input, OnChanges, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.css']
})
export class ProgressComponent implements OnChanges {


  @Input() step: string;
  @Input() cant_locations_in_manifest: any;
  @Input() cant_locations_in_sales: any;
  @Input() cant_locations_in_testing: any;
  @Input() cant_locations_processed: any;
  @Input() cant_locations_received: any;
  @Input() cant_locations_shipped: any;
  @Input() po: string;
  @Input() itemsOnDepartament = {
    numInmanifest: 0,
    numInsales: 0,
    numIntesting: 0,
    numReceived: 0,
    num_processed: 0,
    num_inmanifest_second: 0,
    num_insales_second: 0,
    num_intesting_second: 0,
    num_received_second: 0,
    num_processed_second: 0,
    num_inmanifest_third: 0,
    num_insales_third: 0,
    num_intesting_third: 0,
    num_received_third: 0,
    num_processed_third: 0,
    num_inmanifest_fourth: 0,
    num_insales_fourth: 0,
    num_intesting_fourth: 0,
    num_received_fourth: 0,
    num_processed_fourth: 0,
    beenInmanifest: 0,
    beenInsales: 0,
    beenIntesting: 0,
    beenReceived: 0,
  };
  @Output() newstep =  new EventEmitter<string>();
  public p: number = 0;
  public itemsProcesados = false;

  constructor() { }

  ngOnChanges(changes) {
    this.p = this.progreso();
    this.itemsProcesados = this.procesados();
    if (changes['step']) {}

    if (changes['itemsOnDepartament']) {
      console.log(this.itemsOnDepartament);
      // this.p = this.progreso();
    }
  }

  goContainer(step) {
    window.open(`container-inventory/${step}/${this.po}`);
  }

  emit(step: string) {
    this.newstep.emit(step);
  }

  statusActive(status: string): boolean {
    switch (status) {
      case 'Received':
          return (
            this.itemsOnDepartament.num_processed > 0 ||
            this.itemsOnDepartament.numInsales > 0 ||
            this.itemsOnDepartament.numIntesting > 0 ||
            this.itemsOnDepartament.numInmanifest > 0 ||
            this.itemsOnDepartament.numReceived > 0 ||
            this.itemsOnDepartament.num_processed_second > 0 ||
            this.itemsOnDepartament.num_insales_second > 0 ||
            this.itemsOnDepartament.num_intesting_second > 0 ||
            this.itemsOnDepartament.num_inmanifest_second > 0 ||
            this.itemsOnDepartament.num_received_second > 0 ||
            this.itemsOnDepartament.num_processed_third > 0 ||
            this.itemsOnDepartament.num_insales_third > 0 ||
            this.itemsOnDepartament.num_intesting_third > 0 ||
            this.itemsOnDepartament.num_inmanifest_third > 0 ||
            this.itemsOnDepartament.num_received_third > 0 ||
            this.itemsOnDepartament.num_processed_fourth > 0 ||
            this.itemsOnDepartament.num_insales_fourth > 0 ||
            this.itemsOnDepartament.num_intesting_fourth > 0 ||
            this.itemsOnDepartament.num_inmanifest_fourth > 0 ||
            this.itemsOnDepartament.num_received_fourth > 0
            );
      case 'Maifest':
        return (
            this.itemsOnDepartament.num_processed > 0 ||
            this.itemsOnDepartament.numInsales > 0 ||
            this.itemsOnDepartament.numIntesting > 0 ||
            this.itemsOnDepartament.numInmanifest > 0 ||
            this.itemsOnDepartament.num_processed_second > 0 ||
            this.itemsOnDepartament.num_insales_second > 0 ||
            this.itemsOnDepartament.num_intesting_second > 0 ||
            this.itemsOnDepartament.num_inmanifest_second > 0 ||
            this.itemsOnDepartament.num_processed_third > 0 ||
            this.itemsOnDepartament.num_insales_third > 0 ||
            this.itemsOnDepartament.num_intesting_third > 0 ||
            this.itemsOnDepartament.num_inmanifest_third > 0 ||
            this.itemsOnDepartament.num_processed_fourth > 0 ||
            this.itemsOnDepartament.num_insales_fourth > 0 ||
            this.itemsOnDepartament.num_intesting_fourth > 0 ||
            this.itemsOnDepartament.num_inmanifest_fourth > 0
          );
      case 'Testing':
        return (
            this.itemsOnDepartament.num_processed > 0 ||
            this.itemsOnDepartament.numInsales > 0 ||
            this.itemsOnDepartament.numIntesting > 0 ||
            this.itemsOnDepartament.num_processed_second > 0 ||
            this.itemsOnDepartament.num_insales_second > 0 ||
            this.itemsOnDepartament.num_intesting_second > 0 ||
            this.itemsOnDepartament.num_processed_third > 0 ||
            this.itemsOnDepartament.num_insales_third > 0 ||
            this.itemsOnDepartament.num_intesting_third > 0 ||
            this.itemsOnDepartament.num_processed_fourth > 0 ||
            this.itemsOnDepartament.num_insales_fourth > 0 ||
            this.itemsOnDepartament.num_intesting_fourth > 0
          );
      case 'Sale':
        return (
            this.itemsOnDepartament.num_processed > 0 ||
            this.itemsOnDepartament.numInsales > 0 ||
            this.itemsOnDepartament.num_processed_second > 0 ||
            this.itemsOnDepartament.num_insales_second > 0 ||
            this.itemsOnDepartament.num_processed_third > 0 ||
            this.itemsOnDepartament.num_insales_third > 0 ||
            this.itemsOnDepartament.num_processed_fourth > 0 ||
            this.itemsOnDepartament.num_insales_fourth > 0
          );
      case 'Processed':
        return (
            this.itemsOnDepartament.num_processed > 0 ||
            this.itemsOnDepartament.num_processed_second > 0 ||
            this.itemsOnDepartament.num_processed_third > 0  ||
            this.itemsOnDepartament.num_processed_fourth > 0
          );
      default:
        return false;
    }
  }

  progreso(): number {

    if (this.step === 'PROCESSED' || this.statusActive('Processed')) {
      return 100;
    } else if (this.step === 'INSALES' || this.statusActive('Sale')) {
      return 82;
    } else if (this.step === 'INTESTING' || this.statusActive('Testing')) {
      return 66;
    } else if (this.step === 'INMANIFEST' || this.statusActive('Maifest')) {
      return 50;
    } else if (this.step === 'RECEIVED' || this.statusActive('Received')) {
      return 33;
    } else if (this.step === 'PICKEDUP' || this.statusActive('Received')) {
      return 17;
    } else if (this.step === 'INTRANSIT') {
      return 0;
    }  else {
      return 0
    }
  }

  procesados() {
    if (this.step === 'PICKEDUP' || this.step === 'INTRANSIT') { return false; }
    if (
      this.itemsOnDepartament.numInsales > 0 ||
      this.itemsOnDepartament.numIntesting > 0 ||
      this.itemsOnDepartament.numInmanifest > 0 ||
      this.itemsOnDepartament.numReceived > 0 ||
      this.itemsOnDepartament.num_insales_second > 0 ||
      this.itemsOnDepartament.num_intesting_second > 0 ||
      this.itemsOnDepartament.num_inmanifest_second > 0 ||
      this.itemsOnDepartament.num_received_second > 0 ||
      this.itemsOnDepartament.num_insales_third > 0 ||
      this.itemsOnDepartament.num_intesting_third > 0 ||
      this.itemsOnDepartament.num_inmanifest_third > 0 ||
      this.itemsOnDepartament.num_received_third > 0 ||
      this.itemsOnDepartament.num_insales_fourth > 0 ||
      this.itemsOnDepartament.num_intesting_fourth > 0 ||
      this.itemsOnDepartament.num_inmanifest_fourth > 0 ||
      this.itemsOnDepartament.num_received_fourth > 0
    ) {
      return false;
    }

    return true;
  }

  recived(): boolean {
    return this.itemsProcesados ||
    this.itemsOnDepartament.beenInmanifest !== 0 || 
    this.itemsOnDepartament.numReceived > 0 || 
    this.itemsOnDepartament.num_received_second > 0 ||
    this.itemsOnDepartament.num_received_third > 0 ||
    this.itemsOnDepartament.num_received_fourth > 0;
  }

  manifest(): boolean {
    return this.itemsProcesados ||
    this.itemsOnDepartament.beenInmanifest !== 0 || 
    this.itemsOnDepartament.numInmanifest > 0 || 
    this.itemsOnDepartament.num_inmanifest_second > 0 ||
    this.itemsOnDepartament.num_inmanifest_third > 0 ||
    this.itemsOnDepartament.num_inmanifest_fourth > 0;
  }

  testing(): boolean {
    return this.itemsProcesados ||
    this.itemsOnDepartament.beenIntesting !== 0 || 
    this.itemsOnDepartament.numIntesting > 0 || 
    this.itemsOnDepartament.num_intesting_second > 0 ||
    this.itemsOnDepartament.num_intesting_third > 0 ||
    this.itemsOnDepartament.num_intesting_fourth > 0;
  }

  sales(): boolean {
    return this.itemsProcesados ||
    this.itemsOnDepartament.beenInsales !== 0 || 
    this.itemsOnDepartament.numInsales > 0 || 
    this.itemsOnDepartament.num_insales_second > 0 ||
    this.itemsOnDepartament.num_insales_third > 0 ||
    this.itemsOnDepartament.num_insales_fourth > 0;
  }

  processed(): boolean {
    return false;
  }
}
